{
  "search": "Пошук",
  "searchWithin": "Пошук у"
}
